import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FormError from "../../../shared/components/FormError";
import { loadEmployeeStatusUpdateDataRequest } from "../redux/Actions";
import EmployeeStatusForm from "./EmployeeStatusForm";

const EmployeeStatusEdit = ({ handleClose, employeeStatus }) => {
  const dispatch = useDispatch();
  let [shouldCloseModal, setShouldCloseModal] = useState(false);
  let [errorMessage, setErrorMessage] = useState(false);

  let { loading, error } = useSelector((state) => state.employeeStatus);

  // After submition, the post request is done loading, and there's no errors
  useEffect(() => {
    if (shouldCloseModal && !loading) {
      if (!error) {
        handleClose(true);
      } else {
        setErrorMessage(error.msg);
      }
      setShouldCloseModal(false);
    }
  }, [loading, error, shouldCloseModal]);

  function submit(values) {
    dispatch(loadEmployeeStatusUpdateDataRequest(values));
    setShouldCloseModal(true);
  }
  function cancel() {
    handleClose(false);
  }
  return (
    <>
      <FormError>
        {errorMessage}
      </FormError>
      <EmployeeStatusForm
        submit={submit}
        cancel={cancel}
        employeeStatus={employeeStatus}
      />
      ;
    </>
  );
};

export default EmployeeStatusEdit;
